import 'normalize.css/normalize.css';

import { injectGlobal } from 'emotion';
import logoLoading from 'images/cis/logo-loading.png';

injectGlobal`
  /* global.css */
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,500,700|Roboto:400,500,700&display=swap&subset=chinese-traditional');

  html {
    height: 100%;
  }

  body {
    position: relative;
    font-size: 1em;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    overflow: auto;
  }

  body:lang(ar) > div{
    transform: scaleX(-1);
  }

  body:lang(ar) input,
  body:lang(ar) textarea
  {
    transform: scaleX(-1);
    direction: rtl;
  }

  body, .MuiTypography-root.MuiTypography-root {
    font-family: 'Helvetica Neue', Helvetica, 'Roboto', Arial, 'Noto Sans TC',
      'Apple LiGothic', '微軟正黑體', 'Microsoft JhengHei', sans-serif;
  }

  body.freeze {
    position: fixed;
  }

  /* loading.css */

  @keyframes loading-rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes loading-dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -40px;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -120px;
    }
  }

  #loading {
    width: 100%;
    height: 100%;
    padding: 200px 0 0;
    color: #989898;
    background-color: #fff;
    box-sizing: border-box;
    position: fixed;
    text-align: center;
    top: 0;
    left: 0;
    z-index: 99;
  }

  #loading.removing {
    opacity: 0;
    transition: opacity 0.3s;
  }

  #loading .loading-logo {
    :lang(ar){
			transform: scaleX(-1);
		}
    display: block;
    width: 240px;
    height: 60px;
    margin: 0 auto 16px;
    background-image: url(${logoLoading});
    background-position: 0 -100%;
    background-size: 100% auto;
  }

  #loading .loading-logo.removing {
    width: 20px;
    height: 5px;
    opacity: 0;
    transition: all 0.6s;
  }

  #loading .loading-icon svg {
    width: 30px;
    height: 30px;
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-animation: Loading__loading-rotate___3LqhG 2s linear infinite;
    /* stylelint-enable */
    animation: loading-rotate 2s linear infinite;
  }

  #loading .loading-icon svg circle {
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-animation: loading-dash 1.5s ease-in-out infinite;
    /* stylelint-enable */
    animation: loading-dash 1.5s ease-in-out infinite;
    stroke-dasharray: 90, 150;
    stroke-dashoffset: 0;
    stroke-width: 2;
    stroke: #989898;
    stroke-linecap: round;
  }

  #loading .loading-icon.removing {
    opacity: 0;
    transition: opacity 0.3s;
  }

`;
